export default "__VITE_ASSET__004445d4__"